module.exports = __webpack_public_path__ + "img/icon3.2f0acaea.png";